import styled from 'styled-components';
import { S as SpinnerInput } from './SpinnerInput/SpinnerInput-D7hyN-Ax.js';

const TimeInputSubInput = /*#__PURE__*/styled(SpinnerInput).withConfig({
  componentId: "sc-storm-ui-40026394__sc-mu5imv-0"
})(["&&{font:", ";background-color:unset;box-shadow:none;height:auto;border:none;margin:0;background:none;text-align:center;border-radius:0;padding-block:0;padding-inline:0;padding:0;width:1.25rem;line-height:unset;outline:none;position:unset;transition:unset;color:inherit;vertical-align:unset;:focus{outline:none;box-shadow:none;border:none;}}"], ({
  theme
}) => theme.font.text.base.default);
TimeInputSubInput.displayName = 'TimeInputSubInput';
const TimeInputInputGroup = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40026394__sc-mu5imv-1"
})(["flex:1 0 auto;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:center;align-items:center;label{padding:0px;}"]);
TimeInputInputGroup.displayName = 'TimeInputInputGroup';
const NativeTimeInput = /*#__PURE__*/styled.input.withConfig({
  componentId: "sc-storm-ui-40026394__sc-mu5imv-2"
})(["&&&{height:", ";}"], ({
  theme
}) => theme.spacing.base.default);

export { NativeTimeInput as N, TimeInputInputGroup as T, TimeInputSubInput as a };
//# sourceMappingURL=CustomTimeInput.styles-CBFnTho1.js.map
